import { AuthGuard, CrudOp, megTemplateAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const MegTemplateView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  return (
    <AuthGuard authScope={megTemplateAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyMegTemplateView projectId={projectId} subprojectId={subprojectId}/></Suspense>
    </AuthGuard>
  );
};

const LazyMegTemplateView = lazy(importView(
  () => import("../components/MegTemplateView"),
  (it) => it.MegTemplateView,
));
